import React, { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';

import { useCreateFlash, useCurrentUser } from '@hooks';
import {
  edit_topics_settings_path,
  edit_user_email_settings_path,
  new_session_path,
  unsubscribe_path,
} from '@routes';
import { READ_ONLY_MODE } from '@src/env';

import NavContent from './Content';

const client = new QueryClient();

const ELIGIBLE_PATH_TO_ACCESS_WITH_JWT = [
  edit_user_email_settings_path(),
  edit_topics_settings_path(),
  unsubscribe_path(),
];

const Nav = () => {
  const { currentUser } = useCurrentUser(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { mutate: createFlashMessage } = useCreateFlash(
    new_session_path({ returning_url: location.pathname })
  );

  useEffect(() => {
    if (READ_ONLY_MODE) {
      navigate('/settings');
    } else if (
      currentUser?.authenticated_by_jwt &&
      !ELIGIBLE_PATH_TO_ACCESS_WITH_JWT.includes(location.pathname)
    ) {
      createFlashMessage({
        type: 'notice',
        message: 'You must be logged in to access that page',
      });
      return null;
    }
  }, [location.pathname, createFlashMessage, currentUser?.authenticated_by_jwt, navigate]);

  return (
    <QueryClientProvider client={client}>
      <NavContent />
    </QueryClientProvider>
  );
};

export default Nav;
